<template>
  <section>
    <div class="content_bg">
      <div class="blue_bg"></div>
      <img class="welcome_bg" height="38.31" src="@/assets/images/welcome_bg.png" />
      <div class="content">
        <div style="padding: 0 20px;">
          <p class="welcome_text1">
            <span style="color: #215fe6">먼데이리스</span><span class="welcome_text1_sub"> 는</span>
            <br />
            <span style="color: #f75757">서비스의 성공</span><span class="welcome_text1_sub"> 을 실현하는</span>
            <br /><span style="color: #a91eff">Full-Stack</span><span class="welcome_text1_sub"> 개발사입니다.</span>
          </p>
          <br/>
          <ul class="welcome_text2">
            <li>누적된 서비스 성공 경험을 바탕으로 <br /><span style="color: #f75757">검증된</span> 기능 모듈 보유</li>
            <li>'Small Code' 엔진을 통한 <br /><span style="color: #a91eff">빠른</span> 서비스 구축</li>
            <li>런칭부터 성장까지, <br /><span style="color: #215fe6">안정적인</span> 서비스를 만듭니다</li>
          </ul>
        </div>
        <img width="300" src="@/assets/images/welcomebox_mobile.png" />
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "../components/Caption.vue";
export default {
  components: {
    Caption,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 840px;
  position: relative;
  overflow: hidden;
  background-color: #ffffff;
}
.blue_bg {
  position:absolute;
  width: 100vw;
  height: 160px; 
  bottom: 0;
  background-color: #215fe6;
}

.welcome_bg {
  position:absolute;
  width: 100vw;
  max-width: 100vw;
  bottom: 0;
  margin-bottom: 150px;
}

.content {
  position:absolute;
  text-align: center;
  width: 100wh;
  max-width: 100vw;
  padding-top: 70px;
}

.welcome_text1 {
  font-weight: 700;
  font-size: 36px;
  color: #000000;
  letter-spacing: -1px;
  margin-bottom: 0.5em;
}

.welcome_text2 {
  margin-top: 20px;
  margin-bottom: 40px;
  font-size: 20px;
  color: #495057;
  letter-spacing: 0;
  line-height: 28px;
  list-style: none;
  padding-left: 0;
}

.welcome_text2 li {
  margin-bottom: 12px;
}

.welcome_text2 li:last-child {
  margin-bottom: 0;
}

.welcome_text1_sub {
  font-size: 28px;
}
</style>
  